import React from 'react';
import Button from '../atoms/Button';
import CustomModal from '../atoms/CustomModal';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  onCancel: () => void;
  data: { type?: 'IMAGE' | 'VIDEO'; url?: string } | null;
};

export default function PreviewFile({ open, onCancel, data }: Props) {
  const { t } = useTranslation();

  return (
    <CustomModal centered open={open} onCancel={onCancel} title={t('components.preview_file')}>
      <div className="space-y-4">
        <div className="h-[400px] w-full">
          {data?.type === 'IMAGE' ? (
            <img
              src={data?.url}
              alt="Preview"
              className="w-full h-full object-contain rounded-lg"
            />
          ) : data?.type === 'VIDEO' ? (
            <video controls className="w-full h-full rounded-lg" autoPlay>
              <source src={data?.url} />
            </video>
          ) : null}
        </div>

        <div className="flex justify-end">
          <Button type="button" onClick={onCancel}>
            {t('components.done')}
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}
